// src/plugins/textPlugin.js
import textService from '@/services/textService'


export default {
  install(app) {
    app.config.globalProperties.$t = function(key, params = {}) {
      return textService.getText(key, params)
    }

    // برای استفاده در Composition API
    app.provide('$t', (key, params) => textService.getText(key, params))
  }
}